(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["devinos-bf-six-pack-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-dv-bf-product]');
    var times = { vip: Date.parse('2026-11-22T20:00:00+01:00'), public: Date.parse('2026-11-23T00:00:00+01:00'), end: Date.parse('2026-12-01T00:00:00+01:00') };
    function phaseAt(now) {
      if (now < times.vip) return 'before';
      if (now < times.public) return 'vip';
      if (now < times.end) return 'public';
      return 'ended';
    }
    function refresh(root) {
      var phase = phaseAt(Date.now());
      var open = phase === 'vip' || phase === 'public';
      var available = root.getAttribute('data-variant-available') === 'true';
      var wrap = root.querySelector('[data-dv-bf-product-form]');
      var button = root.querySelector('button[type="submit"]');
      var message = root.querySelector('[data-dv-bf-product-message]');
      root.classList.remove('dv-bf-product--before', 'dv-bf-product--vip', 'dv-bf-product--public', 'dv-bf-product--ended');
      root.classList.add('dv-bf-product--' + phase);
      root.setAttribute('data-presented-phase', phase);
      if (wrap) wrap.hidden = !(open && available);
      var blocked = wrap && wrap.getAttribute('data-dv-purchase-blocked') === 'true';
      var checking = wrap && wrap.getAttribute('data-dv-purchase-checking') === 'true';
      var notice = wrap && wrap.querySelector('[role="alert"]');
      if (button) button.disabled = !(open && available) || blocked || checking;
      if (notice && open && available && !blocked && !checking) notice.hidden = true;
      if (message) {
        message.hidden = open && available;
        if (phase === 'ended') message.textContent = 'Kampagnen er afsluttet. Se DeVinos’ øvrige vine.';
        else if (!available) message.textContent = 'Kassen er ikke tilgængelig lige nu. Se DeVinos’ øvrige vine.';
        else message.textContent = 'Tidlig adgang åbner søndag 22. november kl. 20.00.';
      }
    }
    roots.forEach(function (root) {
      var timer;
      function schedule() {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () { refresh(root); schedule(); }, Math.max(1000, 60000 - (Date.now() % 60000) + 100));
      }
      refresh(root);
      schedule();
      document.addEventListener('visibilitychange', function () { if (!document.hidden) { refresh(root); schedule(); } });
    });
  }());

  (function () {
    var start = Date.parse('2026-11-22T20:00:00+01:00');
    var end = Date.parse('2026-12-01T00:00:00+01:00');
    function openNow() { var now = Date.now(); return now >= start && now < end; }
    document.querySelectorAll('[data-dv-purchase]').forEach(function (wrap) {
      var form = wrap.querySelector('form');
      var button = wrap.querySelector('button[type="submit"]');
      if (!form || !button || form.dataset.dvPurchaseGuard === 'bound') return;
      form.dataset.dvPurchaseGuard = 'bound';
      var checking = false;
      var verified = false;
      var notice = document.createElement('p');
      notice.setAttribute('role', 'alert');
      notice.hidden = true;
      wrap.appendChild(notice);
      form.addEventListener('submit', async function (event) {
        if (wrap.getAttribute('data-dv-purchase-blocked') === 'true') { event.preventDefault(); return; }
        if (!openNow()) {
          event.preventDefault();
          verified = false;
          notice.textContent = Date.now() < start ? 'Køb åbner 22. november kl. 20.00.' : 'Kampagnen er afsluttet. Se vores øvrige vine.';
          notice.hidden = false;
          button.disabled = true;
          return;
        }
        if (verified) { verified = false; return; }
        event.preventDefault();
        if (checking) return;
        checking = true;
        wrap.setAttribute('data-dv-purchase-checking', 'true');
        button.disabled = true;
        notice.hidden = true;
        try {
          var response = await fetch(wrap.getAttribute('data-product-json-url'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('unavailable');
          var current = await response.json();
          var variant = (current.variants || []).find(function (item) { return String(item.id) === wrap.getAttribute('data-expected-variant'); });
          if (String(current.id) !== wrap.getAttribute('data-expected-product') || !variant || !variant.available || variant.sku !== wrap.getAttribute('data-expected-sku') || Number(variant.price) !== Number(wrap.getAttribute('data-expected-price')) || !openNow()) throw new Error('changed');
          var id = form.querySelector('[name="id"]');
          var quantity = form.querySelector('[name="quantity"]');
          if (!id || !quantity || id.value !== String(variant.id) || quantity.value !== '1') throw new Error('changed');
          button.disabled = false;
          verified = true;
          form.requestSubmit(button);
        } catch (error) {
          verified = false;
          notice.textContent = 'Kassen kan ikke lægges i kurven lige nu. Opdatér siden for at se pris og tilgængelighed.';
          notice.hidden = false;
          wrap.setAttribute('data-dv-purchase-blocked', 'true');
          button.disabled = true;
        } finally { checking = false; wrap.removeAttribute('data-dv-purchase-checking'); }
      });
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["devinos-bf-six-packs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-campaign="devinos-bf2026-six-packs"]');
    var times = { vipStart: Date.parse('2026-11-22T20:00:00+01:00'), publicStart: Date.parse('2026-11-23T00:00:00+01:00'), saleEnd: Date.parse('2026-12-01T00:00:00+01:00') };
    function phaseAt(timestamp) {
      if (timestamp < times.vipStart) return 'before';
      if (timestamp < times.publicStart) return 'vip';
      if (timestamp < times.saleEnd) return 'public';
      return 'ended';
    }
    function activate(root) {
      var phase = phaseAt(Date.now());
      var open = phase === 'vip' || phase === 'public';
      root.classList.remove('dv-six-packs--before', 'dv-six-packs--vip', 'dv-six-packs--public', 'dv-six-packs--ended');
      root.classList.add('dv-six-packs--' + phase);
      root.setAttribute('data-presented-phase', phase);
      root.querySelectorAll('[data-dv-six-form]').forEach(function (formWrap) {
        var card = formWrap.closest('[data-dv-offer]');
        var available = card && card.getAttribute('data-offer-available') === 'true';
        formWrap.hidden = !(open && available);
        var button = formWrap.querySelector('button[type="submit"]');
        var blocked = formWrap.getAttribute('data-dv-purchase-blocked') === 'true';
        var checking = formWrap.getAttribute('data-dv-purchase-checking') === 'true';
        var notice = formWrap.querySelector('[role="alert"]');
        if (button) button.disabled = !(open && available) || blocked || checking;
        if (notice && open && available && !blocked && !checking) notice.hidden = true;
      });
      root.querySelectorAll('[data-dv-six-message]').forEach(function (message) {
        var card = message.closest('[data-dv-offer]');
        var available = card && card.getAttribute('data-offer-available') === 'true';
        message.hidden = open && available;
        if (phase === 'ended') message.textContent = 'Kampagnen er afsluttet. Se DeVinos’ øvrige vine.';
        else if (!available) message.textContent = 'Kassen er ikke tilgængelig lige nu. Se DeVinos’ øvrige vine.';
        else message.textContent = 'Køb åbner ved VIP-adgangen 22. november kl. 20.00.';
      });
    }
    roots.forEach(function (root) {
      var timer;
      function schedule() {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () { activate(root); schedule(); }, Math.max(1000, 60000 - (Date.now() % 60000) + 100));
      }
      activate(root);
      schedule();
      document.addEventListener('visibilitychange', function () { if (!document.hidden) { activate(root); schedule(); } });
    });
  }());

  (function () {
    var start = Date.parse('2026-11-22T20:00:00+01:00');
    var end = Date.parse('2026-12-01T00:00:00+01:00');
    function openNow() { var now = Date.now(); return now >= start && now < end; }
    document.querySelectorAll('[data-dv-purchase]').forEach(function (wrap) {
      var form = wrap.querySelector('form');
      var button = wrap.querySelector('button[type="submit"]');
      if (!form || !button || form.dataset.dvPurchaseGuard === 'bound') return;
      form.dataset.dvPurchaseGuard = 'bound';
      var checking = false;
      var verified = false;
      var notice = document.createElement('p');
      notice.setAttribute('role', 'alert');
      notice.hidden = true;
      wrap.appendChild(notice);
      form.addEventListener('submit', async function (event) {
        if (wrap.getAttribute('data-dv-purchase-blocked') === 'true') { event.preventDefault(); return; }
        if (!openNow()) {
          event.preventDefault();
          verified = false;
          notice.textContent = Date.now() < start ? 'Køb åbner 22. november kl. 20.00.' : 'Kampagnen er afsluttet. Se vores øvrige vine.';
          notice.hidden = false;
          button.disabled = true;
          return;
        }
        if (verified) { verified = false; return; }
        event.preventDefault();
        if (checking) return;
        checking = true;
        wrap.setAttribute('data-dv-purchase-checking', 'true');
        button.disabled = true;
        notice.hidden = true;
        try {
          var response = await fetch(wrap.getAttribute('data-product-json-url'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('unavailable');
          var current = await response.json();
          var variant = (current.variants || []).find(function (item) { return String(item.id) === wrap.getAttribute('data-expected-variant'); });
          if (String(current.id) !== wrap.getAttribute('data-expected-product') || !variant || !variant.available || variant.sku !== wrap.getAttribute('data-expected-sku') || Number(variant.price) !== Number(wrap.getAttribute('data-expected-price')) || !openNow()) throw new Error('changed');
          var id = form.querySelector('[name="id"]');
          var quantity = form.querySelector('[name="quantity"]');
          if (!id || !quantity || id.value !== String(variant.id) || quantity.value !== '1') throw new Error('changed');
          button.disabled = false;
          verified = true;
          form.requestSubmit(button);
        } catch (error) {
          verified = false;
          notice.textContent = 'Kassen kan ikke lægges i kurven lige nu. Opdatér siden for at se pris og tilgængelighed.';
          notice.hidden = false;
          wrap.setAttribute('data-dv-purchase-blocked', 'true');
          button.disabled = true;
        } finally { checking = false; wrap.removeAttribute('data-dv-purchase-checking'); }
      });
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["devinos-black-friday-sales"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-campaign="devinos-bf2026-sales"]');
    var phaseClasses = ['before', 'vip', 'public', 'ended'];
    var times = {
      vipStart: Date.parse('2026-11-22T20:00:00+01:00'),
      publicStart: Date.parse('2026-11-23T00:00:00+01:00'),
      saleEnd: Date.parse('2026-12-01T00:00:00+01:00')
    };

    function phaseAt(timestamp) {
      if (timestamp < times.vipStart) return 'before';
      if (timestamp < times.publicStart) return 'vip';
      if (timestamp < times.saleEnd) return 'public';
      return 'ended';
    }

    function phaseCopy(root, phase) {
      var ready = root.getAttribute('data-product-ready') === 'true';
      var available = root.getAttribute('data-variant-available') === 'true';
      var productMessage = !ready
        ? 'Kassen er ikke tilgængelig lige nu. Se vores øvrige vine.'
        : (!available ? 'Kassen er udsolgt lige nu.' : 'Du kan se kassen og lægge den i kurven.');
      if (phase === 'before') return ['VIP-adgangen åbner snart', 'Vi åbner 22. november kl. 20.00', 'Den offentlige åbning følger 23. november kl. 00.00 (dansk tid).'];
      if (phase === 'vip') return ['VIP-adgangen er åben', 'Velkommen til førpremieren', productMessage + ' Den offentlige åbning følger 23. november kl. 00.00.'];
      if (phase === 'public') return ['Black Friday er åben', 'Spansk vin til middagsbordet', ready && available ? 'Se kassen her frem til 30. november kl. 23.59 (dansk tid).' : productMessage];
      return ['Black Friday 2026', 'Kampagnen er afsluttet', 'Black Friday hos DeVinos sluttede 30. november kl. 23.59 (dansk tid).'];
    }

    // Audit C9: kasserne publiceres kl. 20 af Flow. Var siden åben før, er produktdata tomme;
    // genindlæs op til 4 gange inden for 30 min. med stigende, tilfældig pause (v3, 31. okt.).
    function reloadIfNotReady(root, phase) {
      if ((phase !== 'vip' && phase !== 'public') || root.getAttribute('data-product-ready') === 'true') return;
      var key = 'dv_bf26_reloaded_' + location.pathname;
      var rec;
      try {
        rec = JSON.parse(sessionStorage.getItem(key) || '{}');
        if (!rec.t || Date.now() - rec.t > 18e5) rec = { n: 0 };
        if (rec.n >= 4) return;
        rec.n += 1; rec.t = Date.now();
        sessionStorage.setItem(key, JSON.stringify(rec));
      } catch (e) { return; }
      var msg = root.querySelector('[data-dv-phase-copy]');
      if (msg) msg.textContent = 'Åbner nu – siden opdateres om et øjeblik.';
      window.setTimeout(function () { location.reload(); }, (5000 + Math.floor(Math.random() * 20000)) * rec.n);
    }

    function activate(root) {
      var phase = phaseAt(Date.now());
      var available = root.getAttribute('data-variant-available') === 'true';
      var copy = phaseCopy(root, phase);
      var signupLink = root.querySelector('[data-dv-signup-link]');
      if (signupLink) signupLink.hidden = phase !== 'before';
      phaseClasses.forEach(function (name) { root.classList.remove('dv-sale--' + name); });
      root.classList.add('dv-sale--' + phase);
      root.setAttribute('data-presented-phase', phase);
      var kicker = root.querySelector('[data-dv-phase-kicker]');
      var title = root.querySelector('[data-dv-phase-title]');
      var body = root.querySelector('[data-dv-phase-copy]');
      if (kicker) kicker.textContent = copy[0];
      if (title) title.textContent = copy[1];
      if (body) body.textContent = copy[2];
      var form = root.querySelector('[data-dv-sale-form]');
      var purchaseOpen = phase === 'vip' || phase === 'public';
      if (form) {
        form.hidden = !(purchaseOpen && available);
        var submit = form.querySelector('button[type="submit"]');
        var blocked = form.getAttribute('data-dv-purchase-blocked') === 'true';
        var checking = form.getAttribute('data-dv-purchase-checking') === 'true';
        var notice = form.querySelector('[role="alert"]');
        if (submit) submit.disabled = !(purchaseOpen && available) || blocked || checking;
        if (notice && purchaseOpen && available && !blocked && !checking) notice.hidden = true;
      }
      var actionMessage = root.querySelector('[data-dv-action-message]');
      if (actionMessage) {
        actionMessage.hidden = purchaseOpen && available;
        if (phase === 'ended') {
          actionMessage.textContent = 'Kampagnen er afsluttet. Se DeVinos’ øvrige vine.';
        } else if (!available) {
          actionMessage.textContent = 'Udsolgt lige nu. Se produktsiden for status.';
        } else if (!purchaseOpen) {
          actionMessage.textContent = 'Kassen kan ses her nu. Køb åbner ved VIP-adgangen 22. november kl. 20.00.';
        }
      }
      var productLink = root.querySelector('[data-dv-product-link]');
      if (productLink) productLink.hidden = false;
      reloadIfNotReady(root, phase);
    }

    roots.forEach(function (root) {
      var timer;
      function schedule() {
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          activate(root);
          schedule();
        }, Math.max(1000, 60000 - (Date.now() % 60000) + 100));
      }
      activate(root);
      schedule();
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) {
          activate(root);
          schedule();
        }
      });
    });
  }());

  (function () {
    var start = Date.parse('2026-11-22T20:00:00+01:00');
    var end = Date.parse('2026-12-01T00:00:00+01:00');
    function openNow() { var now = Date.now(); return now >= start && now < end; }
    document.querySelectorAll('[data-dv-purchase]').forEach(function (wrap) {
      var form = wrap.querySelector('form');
      var button = wrap.querySelector('button[type="submit"]');
      if (!form || !button || form.dataset.dvPurchaseGuard === 'bound') return;
      form.dataset.dvPurchaseGuard = 'bound';
      var checking = false;
      var verified = false;
      var notice = document.createElement('p');
      notice.setAttribute('role', 'alert');
      notice.hidden = true;
      wrap.appendChild(notice);
      form.addEventListener('submit', async function (event) {
        if (wrap.getAttribute('data-dv-purchase-blocked') === 'true') { event.preventDefault(); return; }
        if (!openNow()) {
          event.preventDefault();
          verified = false;
          notice.textContent = Date.now() < start ? 'Køb åbner 22. november kl. 20.00.' : 'Kampagnen er afsluttet. Se vores øvrige vine.';
          notice.hidden = false;
          button.disabled = true;
          return;
        }
        if (verified) { verified = false; return; }
        event.preventDefault();
        if (checking) return;
        checking = true;
        wrap.setAttribute('data-dv-purchase-checking', 'true');
        button.disabled = true;
        notice.hidden = true;
        try {
          var response = await fetch(wrap.getAttribute('data-product-json-url'), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('unavailable');
          var current = await response.json();
          var variant = (current.variants || []).find(function (item) { return String(item.id) === wrap.getAttribute('data-expected-variant'); });
          if (String(current.id) !== wrap.getAttribute('data-expected-product') || !variant || !variant.available || variant.sku !== wrap.getAttribute('data-expected-sku') || Number(variant.price) !== Number(wrap.getAttribute('data-expected-price')) || !openNow()) throw new Error('changed');
          var id = form.querySelector('[name="id"]');
          var quantity = form.querySelector('[name="quantity"]');
          if (!id || !quantity || id.value !== String(variant.id) || quantity.value !== '1') throw new Error('changed');
          button.disabled = false;
          verified = true;
          form.requestSubmit(button);
        } catch (error) {
          verified = false;
          notice.textContent = 'Kassen kan ikke lægges i kurven lige nu. Opdatér siden for at se pris og tilgængelighed.';
          notice.hidden = false;
          wrap.setAttribute('data-dv-purchase-blocked', 'true');
          button.disabled = true;
        } finally { checking = false; wrap.removeAttribute('data-dv-purchase-checking'); }
      });
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["devinos-case-six"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('devinos-case-six')) {
    customElements.define('devinos-case-six', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          window.addEventListener('pageshow', this.restore);
          this.observeSticky();
          return;
        }
        this.initialized = true;
        this.form = this.querySelector('form');
        this.variantInput = this.form.elements.id;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 });
        this.form.addEventListener('submit', event => this.submit(event));
        this.variantInput.addEventListener('change', () => this.update());
        this.restore = () => { this.busy = false; this.needsCartReview = false; this.update(); };
        window.addEventListener('pageshow', this.restore);
        this.setupGallery();
        this.update();
        this.observeSticky();
      }
      disconnectedCallback() { this.observer?.disconnect(); window.removeEventListener('pageshow', this.restore); }
      setupGallery() {
        const slides = this.querySelector('[data-slides]');
        if (!slides) return;
        const dots = [...this.querySelectorAll('[data-dot]')];
        const thumbs = [...this.querySelectorAll('[data-thumb]')];
        const select = index => {
          dots.forEach((dot, n) => dot.classList.toggle('is-active', n === index));
          thumbs.forEach((thumb, n) => thumb.setAttribute('aria-current', n === index ? 'true' : 'false'));
        };
        slides.addEventListener('scroll', () => {
          cancelAnimationFrame(this.galleryFrame);
          this.galleryFrame = requestAnimationFrame(() => select(Math.round(slides.scrollLeft / slides.clientWidth)));
        }, { passive: true });
        thumbs.forEach((thumb, n) => thumb.addEventListener('click', () => {
          slides.scrollTo({ left: n * slides.clientWidth, behavior: 'smooth' });
          select(n);
        }));
      }
      observeSticky() {
        const sticky = this.querySelector('[data-sticky]');
        const mainButton = this.querySelector('.dv-case-six__form [data-add]');
        if (!sticky || !mainButton) return;
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.target === mainButton) this.purchasePassed = !entry.isIntersecting && entry.boundingClientRect.top < (entry.rootBounds?.top ?? 0);
            else this.sectionVisible = entry.isIntersecting;
          }
          const visible = !!(this.purchasePassed && this.sectionVisible);
          sticky.classList.toggle('is-visible', visible);
          sticky.inert = !visible;
        }, { rootMargin: '-100px 0px 0px 0px' });
        this.observer.observe(this);
        this.observer.observe(mainButton);
      }
      update() {
        this.variant = this.variants.find(variant => String(variant.id) === this.variantInput.value);
        if (!this.variant) return;
        this.querySelectorAll('[data-price]').forEach(node => { node.textContent = this.money.format(this.variant.price / 100); });
        const stock = this.querySelector('[data-stock]');
        if (stock) {
          stock.classList.toggle('dv-case-six__stock--out', !this.variant.available);
          stock.querySelector('[data-stock-text]').textContent = this.variant.available ? this.dataset.inStockLabel : this.dataset.soldLabel;
        }
        this.querySelectorAll('[data-add]').forEach(button => { button.disabled = !this.variant.available || this.busy || this.needsCartReview; });
        this.querySelectorAll('[data-add-text]').forEach(node => { const addLabel = node.closest('[data-short-label]')?.dataset.shortLabel || this.dataset.addLabel; node.textContent = this.busy ? this.dataset.loadingLabel : this.needsCartReview ? this.dataset.reviewLabel : this.variant.available ? addLabel : this.dataset.soldLabel; });
      }
      async submit(event) {
        event.preventDefault();
        if (this.busy || this.needsCartReview || !this.variant?.available) return;
        const error = this.querySelector('[data-error]');
        error.hidden = true;
        this.busy = true;
        this.update();
        try {
          const response = await fetch(this.dataset.addUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form) });
          const result = await response.json();
          if (!response.ok) {
            const failure = new Error(typeof result.description === 'string' ? result.description : this.dataset.errorLabel);
            failure.confirmed = true;
            throw failure;
          }
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          let message = failure.confirmed ? failure.message : this.dataset.errorLabel;
          try {
            const cartResponse = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              if (Number.isFinite(cart.total_price)) message += ' ' + this.dataset.cartTotalLabel + ' ' + this.money.format(cart.total_price / 100) + '.';
            }
          } catch {}
          error.textContent = message;
          error.hidden = false;
          this.querySelector('[data-review-cart]').hidden = false;
          this.needsCartReview = true;
          this.busy = false;
          this.update();
          error.focus();
          error.scrollIntoView({ block: 'center', behavior: 'auto' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["devinos-case"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('devinos-case')) {
    customElements.define('devinos-case', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          window.addEventListener('pageshow', this.restore);
          this.observer.observe(this);
          this.observer.observe(this.querySelector('.dv-case__form [data-add]'));
          return;
        }
        this.initialized = true;
        this.form = this.querySelector('form');
        this.quantity = this.form.elements.quantity;
        this.variantInput = this.form.elements.id;
        this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
        this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
        this.caseBottles = Number(this.dataset.caseBottles || 0);
        this.money = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
        this.querySelector('[data-quantity-minus]').addEventListener('click', () => { this.quantity.stepDown(); this.update(); });
        this.querySelector('[data-quantity-plus]').addEventListener('click', () => { this.quantity.stepUp(); this.update(); });
        this.quantity.addEventListener('change', () => this.update());
        this.variantInput.addEventListener('change', () => this.update(true));
        this.form.addEventListener('submit', event => this.submit(event));
        this.update(true);
        this.restore = () => { this.busy = false; this.needsCartReview = false; this.update(); };
        window.addEventListener('pageshow', this.restore);
        const sticky = this.querySelector('[data-sticky]');
        const nextSection = this.closest?.('.shopify-section')?.nextElementSibling;
        const reviewSection = nextSection?.querySelector('.tp-slider-track') ? nextSection : null;
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            if (entry.target === this) this.sectionVisible = entry.isIntersecting;
            else if (entry.target === reviewSection) this.reviewsVisible = entry.isIntersecting;
            else this.purchasePassed = !entry.isIntersecting;
          }
          sticky.hidden = !((this.sectionVisible || this.reviewsVisible) && this.purchasePassed);
        });
        this.observer.observe(this);
        if (reviewSection) this.observer.observe(reviewSection);
        this.observer.observe(this.querySelector('.dv-case__form [data-add]'));
      }
      disconnectedCallback() { this.observer?.disconnect(); window.removeEventListener('pageshow', this.restore); }
      totalPrice(quantity) {
        return this.variant.price * Number(quantity);
      }
      unitPriceDisplay() {
        const unit = this.labels.unitPrices?.[this.variant.id] || '';
        if (!this.caseBottles) return unit;
        const bottle = this.money.format(this.variant.price / this.caseBottles / 100) + ' ' + this.labels.perBottle;
        return unit ? bottle + ' · ' + unit : bottle;
      }
      update(variantChanged = false) {
        this.variant = this.variants.find(v => String(v.id) === this.variantInput.value);
        if (!this.variant) return;
        const rule = this.variant.quantity_rule || { min: 1, increment: 1 };
        this.quantity.min = rule.min || 1;
        this.quantity.step = rule.increment || 1;
        if (rule.max) this.quantity.max = rule.max; else this.quantity.removeAttribute('max');
        if (variantChanged || !Number.isInteger(Number(this.quantity.value)) || Number(this.quantity.value) < Number(this.quantity.min)) this.quantity.value = this.quantity.min;
        const quantity = Number(this.quantity.value);
        const total = this.totalPrice(quantity);
        const unitPrice = total / quantity;
        this.querySelector('[data-unit-price]').textContent = this.money.format(unitPrice / 100);
        this.querySelectorAll('[data-total]').forEach(node => { node.textContent = this.money.format(total / 100); });
        this.querySelectorAll('[data-unit-measure]').forEach(node => { const unit = this.unitPriceDisplay(); node.textContent = unit; node.hidden = !unit; });
        this.querySelectorAll('[data-selected-quantity]').forEach(node => { node.textContent = quantity; });
        this.querySelectorAll('[data-selected-label]').forEach(node => { node.textContent = quantity === 1 ? this.labels.caseSingular : this.labels.casePlural; });
        this.querySelector('[data-stock]').textContent = this.variant.available ? this.labels.inStock : this.dataset.soldLabel;
        this.querySelector('[data-shipping]').textContent = this.dataset.currency === 'DKK' && this.variant.price * Number(this.quantity.value) >= 49900 ? this.labels.freeShipping : this.labels.shippingCheckout;
        this.querySelector('[data-quantity-minus]').disabled = Number(this.quantity.value) <= Number(this.quantity.min);
        this.querySelector('[data-quantity-plus]').disabled = !!rule.max && Number(this.quantity.value) >= rule.max;
        this.querySelectorAll('[data-add]').forEach(button => { button.disabled = !this.variant.available || this.busy || this.needsCartReview; });
        this.querySelectorAll('[data-add-text]').forEach(node => { node.textContent = this.busy ? this.dataset.loadingLabel : this.needsCartReview ? this.labels.reviewCart : this.variant.available ? this.dataset.addLabel : this.dataset.soldLabel; });
      }
      async submit(event) {
        event.preventDefault();
        if (this.busy || this.needsCartReview || !this.variant.available || !this.form.reportValidity()) return;
        const error = this.querySelector('[data-error]');
        error.hidden = true;
        this.busy = true;
        this.update();
        try {
          const response = await fetch(this.dataset.addUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form) });
          const result = await response.json();
          if (!response.ok) {
            const failure = new Error(typeof result.description === 'string' ? result.description : this.dataset.errorLabel);
            failure.confirmed = true;
            throw failure;
          }
          window.location.assign(this.dataset.cartUrl);
        } catch (failure) {
          let message = failure.confirmed ? failure.message : this.dataset.errorLabel;
          try {
            const cartResponse = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } });
            if (cartResponse.ok) {
              const cart = await cartResponse.json();
              if (Number.isFinite(cart.total_price)) message += ' ' + this.labels.cartTotal + ' ' + this.money.format(cart.total_price / 100) + '.';
            }
          } catch {}
          error.textContent = message;
          error.hidden = false;
          this.querySelector('[data-review-cart]').hidden = false;
          this.needsCartReview = true;
          this.busy = false;
          this.update();
          error.focus();
          error.scrollIntoView({ block: 'center', behavior: 'auto' });
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["devinos-vip-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-campaign="devinos-bf2026"]');
    var phaseClasses = ['before', 'signup', 'vip', 'public', 'ended'];
    var times = {
      signupStart: Date.parse('2026-10-31T15:00:00+01:00'),
      vipStart: Date.parse('2026-11-22T20:00:00+01:00'),
      publicStart: Date.parse('2026-11-23T00:00:00+01:00'),
      saleEnd: Date.parse('2026-12-01T00:00:00+01:00')
    };

    function phaseAt(timestamp) {
      if (timestamp < times.signupStart) return 'before';
      if (timestamp < times.vipStart) return 'signup';
      if (timestamp < times.publicStart) return 'vip';
      if (timestamp < times.saleEnd) return 'public';
      return 'ended';
    }

    function phaseFor(root) {
      if (window.Shopify && window.Shopify.designMode === true && root.getAttribute('data-dv-editor-preview') === 'signup') return 'signup';
      return phaseAt(Date.now());
    }

    function activate(root) {
      var phase = phaseFor(root);
      root.classList.remove.apply(root.classList, phaseClasses.map(function (name) { return 'dv-vip--' + name; }));
      root.classList.add('dv-vip--' + phase);
      root.querySelectorAll('[data-dv-phase]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-dv-phase') !== phase;
      });
      var signupJump = root.querySelector('[data-dv-signup-jump]');
      if (signupJump) signupJump.hidden = phase !== 'signup';
      var existingNote = root.querySelector('[data-dv-existing-note]');
      if (existingNote) existingNote.hidden = phase !== 'before' && phase !== 'signup';
      var titles = {vip: 'VIP-adgangen er åben', public: 'Black Friday hos DeVinos', ended: 'Tak for denne gang'};
      var intros = {vip: 'Se udvalget før den offentlige åbning 23. november kl. 00.', public: 'Vælg vin til bordet blandt årets Black Friday-kasser.', ended: 'Black Friday 2026 er afsluttet. Du kan stadig finde vin til bordet i vores almindelige udvalg.'};
      var heading = root.querySelector('[data-dv-vip-heading]');
      var intro = root.querySelector('[data-dv-vip-intro]');
      if (heading) heading.textContent = titles[phase] || root.getAttribute('data-signup-heading');
      if (intro) intro.textContent = intros[phase] || root.getAttribute('data-signup-intro');
    }

    function initialize(root) {
      if (root.dataset.dvVipInitialized === 'true') return;
      root.dataset.dvVipInitialized = 'true';
      var timer;
      function schedule() {
        window.clearTimeout(timer);
        if (!root.isConnected) return;
        timer = window.setTimeout(function () {
          activate(root);
          schedule();
        }, Math.max(1000, 60000 - (Date.now() % 60000) + 100));
      }
      var signupForm = root.querySelector('form');
      function onSubmit(event) {
        if (phaseFor(root) !== 'signup') { event.preventDefault(); activate(root); }
      }
      if (signupForm) signupForm.addEventListener('submit', onSubmit);
      function onVisibilityChange() {
        if (!document.hidden && root.isConnected) {
          activate(root);
          schedule();
        }
      }
      function onSectionUnload(event) {
        if (event.target !== root && (!event.target.contains || !event.target.contains(root))) return;
        window.clearTimeout(timer);
        if (signupForm) signupForm.removeEventListener('submit', onSubmit);
        document.removeEventListener('visibilitychange', onVisibilityChange);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
        delete root.dataset.dvVipInitialized;
      }
      activate(root);
      schedule();
      document.addEventListener('visibilitychange', onVisibilityChange);
      document.addEventListener('shopify:section:unload', onSectionUnload);
    }

    roots.forEach(initialize);
    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target;
      if (section.matches && section.matches('[data-campaign="devinos-bf2026"]')) initialize(section);
      if (section.querySelectorAll) section.querySelectorAll('[data-campaign="devinos-bf2026"]').forEach(initialize);
    });
  }());

  } catch(e) { console.error(e); }
})();
})();
